"use strict";
const ENS_NAME_REGEX = /^(([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+)eth(\/.*)?$/;
export default function parseENSAddress(ensAddress) {
  const match = ensAddress.match(ENS_NAME_REGEX);
  if (!match) {
    return void 0;
  }
  return { ensName: `${match[1].toLowerCase()}eth`, ensPath: match[4] };
}
